export const logEventTypes = {
    c: { title: "Додано", value: "c" },
    u: { title: "Оновлено", value: "u" },
    d: { title: "Видалено", value: "d" },
};

export const logEventList = [
    { id: 1, title: "Всі дії", evenType: "", logable_type: "" },
    { id: 2, title: "Додано товар", evenType: "c", logable_type: "product" },
    { id: 3, title: "Оновлено товар", evenType: "u", logable_type: "product" },
    { id: 4, title: "Видалено товар", evenType: "d", logable_type: "product" },
    { id: 5, title: "Додано замовлення", evenType: "c", logable_type: "order" },
    { id: 6, title: "Оновлено замовлення", evenType: "u", logable_type: "order" },
    { id: 7, title: "Видалено замовлення", evenType: "d", logable_type: "order" },
    { id: 8, title: "Додано клієнта", evenType: "c", logable_type: "client" },
    { id: 9, title: "Оновлено клієнта", evenType: "u", logable_type: "client" },
    { id: 10, title: "Видалено клієнта", evenType: "d", logable_type: "client" },
    { id: 11, title: "Додано менеджера", evenType: "c", logable_type: "user" },
    { id: 12, title: "Оновлено менеджера", evenType: "u", logable_type: "user" },
    { id: 13, title: "Видалено менеджера", evenType: "d", logable_type: "user" },
    { id: 14, title: "Додано магазин", evenType: "c", logable_type: "store" },
    { id: 15, title: "Оновлено магазин", evenType: "u", logable_type: "store" },
    { id: 16, title: "Видалено магазин", evenType: "d", logable_type: "store" },
    { id: 17, title: "Додано ремонт", evenType: "c", logable_type: "repair" },
    { id: 18, title: "Оновлено ремонт", evenType: "u", logable_type: "repair" },
    { id: 19, title: "Видалено ремонт", evenType: "d", logable_type: "repair" },
    { id: 20, title: "Додано категорію", evenType: "c", logable_type: "category" },
    { id: 21, title: "Оновлено категорію", evenType: "u", logable_type: "category" },
    { id: 22, title: "Видалено категорію", evenType: "d", logable_type: "category" },
];
